import React, { useEffect, useMemo } from "react";
import {
  Button,
  Col,
  Icon,
  Row,
  RSelect
} from "../../components/Component";

import { ErrorMessage } from "@hookform/error-message";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { toast } from "react-toastify";
import { POST } from "../../helper/api";
import { CURRENCY_CODE, DEFAULT_CUSTOMER } from '../../utils/Utils';
import moment from "moment";

const PNExchangeMoneyBetweenAccounts = ({
  onClose,
  pnBankAccountOptions,
  defaultValue = {},
}) => {

  const { errors, register, handleSubmit, reset, getValues, control, setValue, formState, watch } = useForm(
    {
      defaultValues: { ...DEFAULT_CUSTOMER, ...defaultValue },
    }
  );

  const fromBankAccountId = watch('fromBankAccountId');
  const amountUSD = watch('amountUSD');
  const exchangeRate = watch('exchangeRate');

  const fromBankAccount = useMemo(() => {
    return pnBankAccountOptions.find((c) => c.value === fromBankAccountId)?.data;
  }, [fromBankAccountId, pnBankAccountOptions]);

  useEffect(() => {
    if (!formState.isDirty) {
      return;
    }
    if (fromBankAccount?.currencyCode === CURRENCY_CODE.VND) {
      setValue('amountUSD', undefined);
      setValue('exchangeRate', undefined);
    }

    if (fromBankAccount?.currencyCode === CURRENCY_CODE.USD) {
      setValue('amount', Math.round(amountUSD * exchangeRate) || undefined);
    }
  }, [fromBankAccount, amountUSD, exchangeRate]);



  const onCancel = () => {
    reset({ ...DEFAULT_CUSTOMER });
  }

  const onHandleSubmit = () => {
    const { amount, fromBankAccountId, toBankAccountId, date, content, exchangeRate, amountUSD, pnHookInTransactionHistoryId, pnHookOutTransactionHistoryId } = getValues();

    const formData = {
      date,
      amount,
      fromBankAccountId,
      toBankAccountId,
      content,
      exchangeRate,
      amountUSD,
      pnHookInTransactionHistoryId: pnHookInTransactionHistoryId ? Number(pnHookInTransactionHistoryId) : undefined,
      pnHookOutTransactionHistoryId: pnHookOutTransactionHistoryId ? Number(pnHookOutTransactionHistoryId) : undefined,
    };
    POST("/pn-transaction-history/exchange-money-between-account", formData, {}, true)
      .then(() => {
        toast.success("Chuyển thành công");
        onClose?.();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onClose?.();
      })
      .finally(() => {
        onCancel();
      })
  };

  return <React.Fragment>
    <div className="card card-bordered card-preview">
      <div className="card-inner">
        <h3>Chuyển tiền</h3>
        <div>
          <form onSubmit={handleSubmit(onHandleSubmit)}>
            <input type="hidden" name="pnHookInTransactionHistoryId" ref={register()} />
            <input type="hidden" name="pnHookOutTransactionHistoryId" ref={register()} />
            <Row className="g-3">
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Từ tài khoản
                    <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="fromBankAccountId"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, name, ref }) => (
                        <RSelect
                          inputRef={ref}
                          name={name}
                          options={pnBankAccountOptions}
                          value={pnBankAccountOptions.find(
                            (c) => +c.value === +value
                          )}
                          onChange={(val) => onChange(val.value)}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="fromBankAccountId"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Tới tài khoản
                    <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="toBankAccountId"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, name, ref }) => (
                        <RSelect
                          inputRef={ref}
                          name={name}
                          options={pnBankAccountOptions}
                          value={pnBankAccountOptions.find(
                            (c) => +c.value === +value
                          )}
                          onChange={(val) => onChange(val.value)}
                        />
                      )}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="toBankAccountId"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>

              <Col size="12">
                <div className="form-group">
                  <label className="form-label" >
                    Ngày <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <input
                      className="form-control"
                      type="date"
                      name="date"
                      max={moment().format("YYYY-MM-DD")}

                      ref={register({
                        required: "Vui lòng nhập thông tin",
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="date"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>

              {fromBankAccount?.currencyCode === CURRENCY_CODE.USD && <>
                <Col md="12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Số tiền($)<span className="text-danger">*</span>
                    </label>
                    <div className="form-control-wrap">
                      <Controller
                        control={control}
                        name="amountUSD"
                        rules={{ required: "Vui lòng nhập thông tin" }}
                        render={({ onChange, value, ref }) => (
                          <NumericFormat
                            className="form-control"
                            inputRef={ref}
                            type="text"
                            value={value}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={4}
                            onValueChange={(val) =>
                              onChange(val.floatValue)
                            }
                          />
                        )}
                      />

                      <ErrorMessage
                        errors={errors}
                        name="amount"
                        render={({ message }) => (
                          <span className="invalid">{message}</span>
                        )}
                      />
                    </div>
                  </div>
                </Col>
                <Col md="12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Tỉ giá<span className="text-danger">*</span>
                    </label>
                    <div className="form-control-wrap">
                      <Controller
                        control={control}
                        name="exchangeRate"
                        rules={{ required: "Vui lòng nhập thông tin" }}
                        render={({ onChange, value, ref }) => (
                          <NumericFormat
                            className="form-control"
                            inputRef={ref}
                            type="text"
                            value={value}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={0}
                            onValueChange={(val) =>
                              onChange(val.floatValue)
                            }
                          />
                        )}
                      />

                      <ErrorMessage
                        errors={errors}
                        name="exchangeRate"
                        render={({ message }) => (
                          <span className="invalid">{message}</span>
                        )}
                      />
                    </div>
                  </div>
                </Col>
              </>
              }
              <Col md="12">
                <div className="form-group">
                  <label className="form-label" htmlFor="customer">
                    Số tiền(đ)<span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <Controller
                      control={control}
                      name="amount"
                      rules={{ required: "Vui lòng nhập thông tin" }}
                      render={({ onChange, value, ref }) => (
                        <NumericFormat
                          disabled={fromBankAccount?.currencyCode === CURRENCY_CODE.USD}
                          className="form-control"
                          inputRef={ref}
                          type="text"
                          value={value}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                          onValueChange={(val) =>
                            onChange(val.floatValue)
                          }
                        />
                      )}
                    />

                    <ErrorMessage
                      errors={errors}
                      name="amount"
                      render={({ message }) => (
                        <span className="invalid">{message}</span>
                      )}
                    />
                  </div>
                </div>
              </Col>
              <Col size="12">
                <div className="form-group">
                  <label className="form-label" >
                    Nội dung <span className="text-danger">*</span>
                  </label>
                  <div className="form-control-wrap">
                    <input
                      className="form-control"
                      name="content"
                      ref={register({
                        required: "Vui lòng nhập thông tin",
                      })}
                    />

                  </div>
                </div>
              </Col>

              <Col size="12">
                <Button color="primary" type="submit">
                  <Icon className="plus"></Icon>
                  <span>Chuyển</span>
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  </React.Fragment>

}

export default PNExchangeMoneyBetweenAccounts